import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CartState } from './types';

const initialState: CartState = {
  upgrade: [],
  purchase: 0,
  isCartOpen: false,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setPurchasesInCart: (state, action: PayloadAction<number>) => {
      state.purchase = action.payload;
    },
    removePurchaseFromCart: (state) => {
      state.purchase = initialState.purchase;
    },
    setUpgradesInCart: (state, action: PayloadAction<string[]>) => {
      state.upgrade = action.payload;
    },
    removeUpgradeFromCart: (state) => {
      state.upgrade = initialState.upgrade;
    },
    setIsCartOpen: (state, action: PayloadAction<boolean>) => {
      state.isCartOpen = action.payload;
    },
    resetCart: () => initialState,
  },
});

export const {
  actions: {
    setPurchasesInCart,
    removePurchaseFromCart,
    setUpgradesInCart,
    removeUpgradeFromCart,
    resetCart,
    setIsCartOpen,
  },
  reducer: cartSliceReducer,
} = cartSlice;
